function InputAnswer(props: any) {
  return (
    <input
      type="text"
      autoComplete="off"
      className={
        props.disableunderline ? "inputAnswer" : "inputAnswerUnderlined"
      }
      {...props}
      style={{ width: props.inputwidth }}
    />
  );
}

export default InputAnswer;
